module.exports = __webpack_public_path__ + "img/cp_07.b5114067.png";